import React from "react";
import "./TextColorPicker.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { textColorOptions } from "../../../../utils/colors";
import { useTranslation } from "react-i18next";

function TextColorPicker({ onSelectColor }) {
  const { t } = useTranslation();
  return (
    <div className="text-color-picker-content">
      <div className="text-color-grid">
        {textColorOptions.map((color) => (
          <button
            key={color}
            className="text-color-option"
            style={{ backgroundColor: color }}
            onClick={() => onSelectColor(color)}
            aria-label={t("notes.editor.selectColor", { color })}
          />
        ))}
      </div>
    </div>
  );
}

export default TextColorPicker;
